import { useContext } from 'react';
import { ContextoUsuario } from '../../contextos/usuario/ProvedorUsuario';
import ListagemAdministrativa from './ListagemAdministrativo';
import ListagemInstituicao from './ListagemInstituicoes';

function Home() {
  const { usuario } = useContext(ContextoUsuario);

  return usuario.perfil !== 'Administrador' ? <ListagemInstituicao /> : <ListagemAdministrativa />;
}

export default Home;
